import { Modal, Radio, RadioChangeEvent, Space } from "antd";
import { useEffect, useState } from "react";
import { useModel } from "@@/exports";
import { getCurrentShopData, ShopData } from "@/utils/storage";
import { useExchangeShop } from "@/hooks/useExchangeShop";

interface ShopExchangeModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}
const ShopExchangeModal = ({
  open,
  onCancel,
  onOk,
}: ShopExchangeModalProps) => {
  const { initialState } = useModel("@@initialState");
  const [currentShop, setCurrentShop] = useState<ShopData>({});
  const [shopId, setShopId] = useState(0);
  const exchangeShop = useExchangeShop();

  const handleShopChange = (event: RadioChangeEvent) => {
    setShopId(event.target.value);
  };

  const handleConfirmShopChange = async () => {
    if (shopId === currentShop.shopId) {
      onCancel?.();
      return;
    }
    try {
      await exchangeShop(shopId);
    } catch (error) {
      throw new Error("切换店铺失败");
    }
    onOk?.();
    window.location.replace("/");
  };

  const handleCancel = () => {
    setShopId(currentShop.shopId || 0);
    onCancel?.();
  };

  useEffect(() => {
    const shop: ShopData = getCurrentShopData();
    setCurrentShop(shop);
    setShopId(shop.shopId || 0);
  }, []);

  return (
    <Modal
      open={open}
      title="切换店铺"
      onOk={handleConfirmShopChange}
      onCancel={handleCancel}
    >
      <Radio.Group onChange={handleShopChange} value={shopId}>
        <Space direction="vertical">
          {initialState?.currentUser?.suppliers?.map((item) => (
            <Radio key={item.shopId} value={item.shopId}>
              {item.shopName}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default ShopExchangeModal;
